import type { FC } from 'react';
import type { NextRouter } from 'next/router';
import { useRouter } from 'next/router';

import { resolveParams } from 'Services/services.helpers';
import { useAccountFiltersStore } from 'Stores/AccountFiltersStore/AccountFiltersStore';
import type { AccountStoreFilters } from 'Stores/AccountFiltersStore/AccountFiltersStore.types';
import SidebarLink from 'Storybook/peripheral/SidebarLink/SidebarLink';
import type { AccountSlugs } from 'Types/account';

import { ACCOUNT_SIDEBAR_ITEMS, ACCOUNT_SIDEBAR_TITLES } from '../AccountSidebar.consts';
import type { AccountSidebarItem, AccountSidebarSectionProps } from '../AccountSidebar.types';
import AccountSidebarTitle from '../AccountSidebarTitle/AccountSidebarTitle';

const AccountSidebarSection: FC<AccountSidebarSectionProps> = ({ countsData, isCountsLoading, section }) => {
	const router: NextRouter = useRouter();

	const store = useAccountFiltersStore((state) => state[section]) as {
		[key in AccountSlugs]: AccountStoreFilters;
	};

	const { icon, title } = ACCOUNT_SIDEBAR_TITLES[section];

	return (
		<>
			<AccountSidebarTitle icon={icon} title={title} />

			{ACCOUNT_SIDEBAR_ITEMS[section].map((item: AccountSidebarItem) => {
				const { as, cypressId, href, isActive, onClick, slug, text } = item;

				const linkStore = store[slug];

				const filterParameters = { ...linkStore, page: 1 };

				return (
					<SidebarLink
						key={as}
						as={`${as}${resolveParams(filterParameters)}`}
						count={countsData?.[slug]}
						cypressId={cypressId}
						href={`${href}${resolveParams(filterParameters)}`}
						isActive={isActive(router)}
						isCountLoading={isCountsLoading}
						onClick={() => {
							onClick?.();
						}}
						text={text}
					/>
				);
			})}
		</>
	);
};

export default AccountSidebarSection;
